/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import './component012.less';

interface IComponent012Props {
  pic1: string;
  pic2: string;
  pic3: string;
  pic5: string;
  title: string;
  content: string;
  className: string;
}

const Component012: React.FunctionComponent<IComponent012Props> = ({
  pic1,
  pic2,
  pic3,
  pic5,
  title,
  content,
  className,
}) => {
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;
  return (
    <>
      <div className="info" dangerouslySetInnerHTML={{ __html: title }} />
      <div className={`business-problem component ${className}`}>
        <img
          style={{ left: 0, bottom: 0 }}
          width="327px"
          src={getImg(pic1)}
          alt=""
        />
        <img
          style={{ left: '330px', bottom: 0 }}
          width="337px"
          src={getImg(pic2)}
          alt=""
        />
        <img
          style={{ left: '390px', top: '111px' }}
          width="75.22px"
          src={getImg(pic3)}
          alt=""
        />
        <img
          style={{ left: '800px', bottom: '50px' }}
          width="385.21px"
          src={getImg(pic5)}
          alt=""
        />
        <div
          className="text"
          style={{ left: '390px', top: '190px' }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </>
  );
};

export default Component012;
